import React, { useMemo } from 'react';

const Indicadores = ({ datos }) => {
    const stats = useMemo(() => {
        if (!datos.length) return { total: 0, velocidadMax: 0, promedio: 0 };
        const total = datos.length;
        const velocidadMax = Math.max(...datos.map((d) => d.VELOCIDAD ?? 0));
        const promedio = Math.floor(
            datos.reduce((sum, d) => sum + (d.VELOCIDAD ?? 0), 0) / total
        );
        return { total, velocidadMax, promedio };
    }, [datos]);

    return (
        <section className="ev-seccion">
            <h3 className="ev-seccion-titulo">
                <i className="pi pi-chart-bar" /> INDICADORES GENERALES — TVP
            </h3>
            <div className="ev-indicadores-grid">
                <div className="ev-ind-card ev-ind-total">
                    <i className="pi pi-list ev-ind-icon" />
                    <div className="ev-ind-info">
                        <span className="ev-ind-label">Total</span>
                        <span className="ev-ind-valor">{stats.total}</span>
                        <span className="ev-ind-sub">incidentes registrados</span>
                    </div>
                </div>
                <div className="ev-ind-card ev-ind-max">
                    <i className="pi pi-bolt ev-ind-icon" />
                    <div className="ev-ind-info">
                        <span className="ev-ind-label">Velocidad Máxima</span>
                        <span className="ev-ind-valor">
                            {stats.velocidadMax} <small>km/h</small>
                        </span>
                        <span className="ev-ind-sub">exceso más alto</span>
                    </div>
                </div>
                <div className="ev-ind-card ev-ind-prom">
                    <i className="pi pi-gauge ev-ind-icon" />
                    <div className="ev-ind-info">
                        <span className="ev-ind-label">Promedio</span>
                        <span className="ev-ind-valor">
                            {stats.promedio} <small>km/h</small>
                        </span>
                        <span className="ev-ind-sub">velocidad promedio</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Indicadores;
